// extracted by mini-css-extract-plugin
export default {"cursor":"TypeWritter_cursor__ZKkLA","blink":"TypeWritter_blink__JgY08"};